// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bgq_a bhu_un bhu_cw bhu_a","MenuItem__Btn":"bgq_b bhu_z"};